module.exports = __webpack_public_path__ + "img/branch_fiji.6d9baf48.png";